import axios from "axios";
import {Notification, MessageBox, Message} from 'element-ui';
import router from "../router";
// axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例 axios.create([config])
var baseUrlStr = "https://sso-api.kjxt.com"
if(location.href.indexOf("sso2.acc5.com") != -1){
  baseUrlStr = "https://sso-api2.acc5.com" //预发布环境
}
if(location.href.indexOf("sso.acc5.com") != -1 && process.env.NODE_ENV === "production"){
  baseUrlStr = "https://sso-api.acc5.com" //正式
}
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL:baseUrlStr,
  //: '/ssoApi', //代理 重写
  // 超时
  timeout: 30000
});
// request拦截器
service.interceptors.request.use(
  config => {
    // 是否需要设置 token
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('access_token');
    //config.headers["token"] =localStorage.getItem('access_token'); // 让每个请求携带自定义token 请根据实际情况自行修改
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = res.data.message;
    if (code === 401 || code === 405) {
      localStorage.removeItem('access_token'); //先 removeToken fix 一直跳转
      if(router.history.current.path != "/login"){ //登录页面 不弹窗
        let msgStr = code === 401 ? '登录状态已过期，请重新登录' : '您的账号已在其它地方登录，请重新登录'
        MessageBox.alert(msgStr, '系统提示', {
          confirmButtonText: '重新登录',
          showClose: false,
          type: 'warning',
        }).then(() => {
          // 跳转登录页
          router.push(
            '/login',
            () => {},
            e => {}
          );
          return false;
        });
      }
    }
    // else if (code === 500) {
    //   Message({
    //     message: msg,
    //     type: 'error',
    //   });
    //   return Promise.reject(new Error(msg));
    // } else if (code !== 200) {
    //   Notification.error({
    //     title: msg,
    //   });
    //   return Promise.reject('error');
    // }
    else {
      return res.data;
    }
  },
  error => {
    let {message} = error;
    if (message == 'Network Error') {
      message = '后端接口连接异常';
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);
export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js